export default "__VITE_ASSET__DDH1iVLM__"